module.exports = __webpack_public_path__ + "static/media/Airpods.ea1d5189.png";